import { Injectable } from '@angular/core';
import { ApiHttpClient } from 'app/http/clients/api';
import { LeadSourceOption } from 'app/models/dto/lead-source-option.model';
import { switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { NewLeadDto } from 'app/models/dto/add-new-lead';
import { Select } from '@ngxs/store';
import { LenderUserState } from 'app/store/lender-user/lender-user/lender-user.state';
import { LenderUser } from 'app/models/dto/lender-user.model';

@Injectable({
  providedIn: 'root'
})
export class LeadSourceOptionService {

  @Select(LenderUserState.lenderUser) lenderUser$: Observable<LenderUser>;

  constructor(private http: ApiHttpClient) { }

  get(): Observable<LeadSourceOption[]> {
    return this.lenderUser$.pipe(
      switchMap(lenderUser => {
        const url = lenderUser.team.type === 'franchise'
          ? '/franchise-marketing-options'
          : '/lead-source-options';
        return this.http.get<LeadSourceOption[]>(url);
      })
    );
  }

  addNewLead(data: Partial<NewLeadDto>) {
    return this.http.post('/borrower-new', data);
  }
}
